import { Behavior } from "../Behavior";
import type { IGrid } from "../types";
import type { Particle } from "../Particle";
import { Fire } from "../particles/Fire";
import { Smoke } from "../particles/Smoke";
import { Charcoal } from "../particles/Charcoal";
import { Empty } from "../particles/Empty";

export class SpreadFire extends Behavior {
    chance: number;

    constructor(chance: number = 0.05) {
        super();
        this.chance = chance;
    }

    update(particle: Particle, grid: IGrid, index: number) {
        // 检查8个方向的邻居，增加传播机会
        const neighbors = [
            index - 1, // left
            index + 1, // right
            index - grid.width, // up
            index + grid.width, // down
            index - grid.width - 1, // top-left
            index - grid.width + 1, // top-right
            index + grid.width - 1, // bottom-left
            index + grid.width + 1, // bottom-right
        ];

        for (const n of neighbors) {
            if (grid.isValid(n)) {
                const neighbor = grid.pixels[n];
                
                if (neighbor && !neighbor.empty) {
                    // 1. 热传递：火/岩浆加热周围任何物体
                    if (particle.temperature > neighbor.temperature) {
                        // 传热系数，控制加热速度
                        // 基础速率 0.05，结合物质的导热率
                        const baseRate = 0.05;
                        const conductivity = neighbor.props.thermalConductivity ?? 1.0;
                        const heatTransferRate = baseRate * conductivity;
                        
                        const diff = particle.temperature - neighbor.temperature;
                        // 只有当温差足够大时才传递，避免微小浮点计算
                        if (diff > 1) {
                            neighbor.temperature += diff * heatTransferRate;
                            
                            // 限制不超过自身温度
                            if (neighbor.temperature > particle.temperature) {
                                neighbor.temperature = particle.temperature;
                            }
                            // 限制不超过邻居最大耐受温度
                            if (neighbor.maxTemp && neighbor.temperature > neighbor.maxTemp) {
                                neighbor.temperature = neighbor.maxTemp;
                            }
                        }
                    }

                    // 2. 点燃逻辑：仅针对可燃物
                    // 显式排除 Charcoal，确保它不会被再次点燃或覆盖
                    if (neighbor.props.isFlammable && !(neighbor instanceof Charcoal)) {
                        const r = Math.random();
                        if (r < this.chance) {
                            // 点燃：将可燃物替换为火
                            grid.setIndex(n, new Fire());
                        } else if (r < this.chance + 0.02) {
                            // 2% 概率将可燃物烧成木炭 (降低生成量)
                            // 木炭刚生成时温度很高
                            grid.setIndex(n, new Charcoal({ temperature: particle.temperature }));
                        } else if (Math.random() < 0.05) {
                            // 增加概率将可燃物烧成灰烬（烟）
                             grid.setIndex(n, new Smoke());
                        }
                    }
                }
            }
        }
    }
}
